export default "__VITE_ASSET__pDiIhKIt__"